/* ============================================================
   Hide bundle-twin products from search results & recommendations
   av-hide-bundle-twins.js
   Save to: Assets/av-hide-bundle-twins.js

   Bundle twin products have handles matching `-bdl-[5 alphanumeric]`
   (e.g., gold-knot-heart-pendant-bdl-hsahx).

   This script hides any product card or search result whose link
   references a URL with that pattern. It runs on:
     - Search results page
     - Predictive search dropdown (as user types)
     - Related products / recommendations
     - Any other page that might accidentally render a twin

   IMPORTANT: It deliberately skips cart-related surfaces (cart page,
   cart drawer, cart sections). Bundle twins SHOULD appear in the
   cart — they're the individual items the customer bought.
   ============================================================ */

(function () {
  'use strict';

  var BUNDLE_PATTERN = /\/products\/[a-z0-9-]+-bdl-[a-z0-9]{4,6}(\b|$|[?#/])/i;

  /* Selectors for DOM regions where twins should be VISIBLE,
     not hidden. If a link's ancestor matches any of these, skip it. */
  var CART_SAFE_SELECTORS = [
    '.cart__item',           // Impulse cart page line items
    '.cart__page',           // Impulse cart page wrapper
    '#CartDrawer',           // Impulse cart drawer
    '#CartDrawerForm',       // Impulse cart drawer form
    '.drawer__contents',     // Impulse drawer wrapper
    '#CartPageForm',         // Impulse cart page form
    '[data-products]',       // Impulse cart products container
    '.ajaxcart',             // Legacy Shopify cart drawer
    '.cart',                 // generic cart container
    '#upcart-drawer',        // UpCart drawer (if installed)
    '.upcart-drawer',        // UpCart drawer variants
    '[data-upcart]',         // UpCart data-attribute
    '.cart-drawer',          // generic cart drawer
    '#cart'                  // generic cart id
  ].join(', ');

  function isHiddenTwinUrl(href) {
    if (!href) return false;
    return BUNDLE_PATTERN.test(href);
  }

  function isInsideCart(el) {
    if (!el || !el.closest) return false;
    return !!el.closest(CART_SAFE_SELECTORS);
  }

  function hideTwinElement(el) {
    if (!el || el.dataset.avTwinHidden === '1') return;
    el.dataset.avTwinHidden = '1';
    el.style.display = 'none';
  }

  function scanAndHide(root) {
    root = root || document;
    if (!root.querySelectorAll) return;

    // If the entire root is inside a cart area, skip it
    if (root !== document && isInsideCart(root)) return;

    var links = root.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (!isHiddenTwinUrl(link.getAttribute('href'))) continue;

      // Skip cart-related surfaces — twins SHOULD show in the cart
      if (isInsideCart(link)) continue;

      var container = link.closest(
        '.grid__item, .grid-item, .grid-product, ' +
        '[role="option"], ' +
        '.results-products__item, li, article, ' +
        '.predictive-search__item, ' +
        '.search-result, .product-card, ' +
        '.grid-search'
      );

      if (container) {
        hideTwinElement(container);
      } else {
        hideTwinElement(link);
      }
    }
  }

  function init() {
    scanAndHide(document);

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node.nodeType === 1) {
              scanAndHide(node);
            }
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
